import newDev from "./devNew.json";
import axios from "axios";
import { REACT_APP_BASE_URL } from "../config";
import { saveServerTimeDelta } from "./serverTime";
import { dev } from "./dev";

const a = `${REACT_APP_BASE_URL}/asic.json`;
const cp = `${REACT_APP_BASE_URL}/coins.json`;

export interface DeviceI {
  name: string;
  niceName: string;
  power: number;
  type: string;
  speed: {
    speed: number;
    algo: string;
  };
}

const factors = [
  { factor: 1000, name: "Scrypt" },
  { factor: 1000000000000, name: "Sha256", coin_name: "Sha" },
  // { factor: 1000000, name: "x11" },
  { factor: 1000, name: "x11" },
  { factor: 1000, name: "x13" },
  //   { factor: 1000000, name: "Keccak" },
  { factor: 1000000, name: "NeoScrypt" },
  //   { factor: 1000000, name: "Qubit" },
  //   { factor: 1000000, name: "Quark" },
  // { factor: 1000000, name: "Lyra2REv2" },
  { factor: 1000000, name: "DaggerHashimoto" },
  { factor: 1000000, name: "Lbry" },
  //   { factor: 1000000, name: "Equihash" },
  { factor: 1000000000, name: "Blake2s" },
  //   { factor: 1000000, name: "Lyra2Z" },
  //   { factor: 1000000, name: "X16R" },
  //   { factor: 1000000, name: "ZHash" },
  //   { factor: 1, name: "GrinCuckatoo31" },
  { factor: 1000, name: "CryptoNight" },
  //   { factor: 1, name: "CuckooCycle" },
  { factor: 1000000, name: "X16Rv2" },
  { factor: 1000, name: "RandomXmonero" },
  //   { factor: 1000000000, name: "Eaglesong" },
  //   { factor: 1, name: "GrinCuckatoo32" },
  { factor: 1000000000, name: "Handshake" },
  //   { factor: 1000000, name: "Kawpow" },
  { factor: 1000000, name: "BeamV3" },
  { factor: 1000000, name: "Octopus" },
  { factor: 1000000, name: "Autolykos" },
  //   { factor: 1000000, name: "ZelHash" },
];
const prefSpeed = (speeds: { [ket: string]: string }) => {
  const arr: any[] = [];
  for (let speed in speeds) {
    if (speeds[speed] !== "0") {
      factors.forEach((fc) => {
        if (fc.name.toLocaleLowerCase() === speed.toLocaleLowerCase()) {
          arr.push({
            algo:
              fc.name === "Sha256"
                ? "sha"
                : // : fc.name === "Decred"
                // ? "blake"
                speed.toLocaleLowerCase(),
            speed: +speeds[speed] * fc.factor,
          });
        }
      });
    }
  }
  return arr.sort((a, b) => b.speed - a.speed)[0];
};

let algorithms: { [key: string]: any }[] = [];
let course: number = 0;

export const getCourse = async () => {
  const bt_course = await axios.get(
    "https://api.bitaps.com/market/v1/ticker/btcusd"
  );
  saveServerTimeDelta(bt_course.headers!.date!);
  course = bt_course.data.data.last;
};

const getAlgorithms = async () => {
  try {
    const coinsARes = await axios.get(a);
    const coinsCPURes = await axios.get(cp);
    saveServerTimeDelta(coinsCPURes.headers!.date!);
    const coinsA: { [key: string]: any } = coinsARes.data.coins;
    const coinsCPU: { [key: string]: any } = coinsCPURes.data.coins;
    algorithms = Object.values({
      ...coinsA,
      ...coinsCPU,
    });
  } catch (e) { // чтобы не было оверлея с ошибкой
    dev.log('NetworkError', e);
  }
};

export const allDevices = async () => {
  await getAlgorithms();

  const ddddddd: any[] = [];
  const { devices }: { [key: string]: any[] } = newDev;
  devices.forEach((item) => {
    if (prefSpeed(JSON.parse(item.speeds)) === undefined) return;
    if (item.category === "CPU") return;
    if (prefSpeed(JSON.parse(item.speeds)).speed === 0) return;
    ddddddd.push({
      name: item.name,
      niceName: item.niceName,
      power: item.power,
      speed: prefSpeed(JSON.parse(item.speeds)),
      type: item.category,
    });
  });
  const clearedDevices: DeviceI[] = ddddddd.filter((item) => {
    for (let i = 0; i < algorithms.length; i++) {
      if (
        algorithms[i].algorithm.toLocaleLowerCase().includes(item.speed.algo)
      ) {
        return true;
      }
    }
    return false; // Добавлен возврат false, если ни одно условие не выполнено
  });
  saveDevices(clearedDevices);
  return clearedDevices;
};

export const calcultion = async (
  { power, speed, type }: DeviceI,
  count = 1,
  perf?: number,
  cons?: number
) => {
  const data = {
    speed: perf !== undefined ? perf * count : speed.speed * count,
    consumpation: cons !== undefined ? cons * count : power * count,
  };
  if (algorithms.length === 0) await getAlgorithms();

  const ab = algorithms
    .filter((item) => item.algorithm.toLocaleLowerCase().includes(speed.algo))
    .sort((a, b) => b.difficulty24 - a.difficulty24);
  const algo = ab[0];
  if (type === "GPU") {
    const btime = algo.difficulty24 / algo.nethash;
    const userRatio = data.speed / algo.nethash;
    const blockPerDay = 86400 / btime;
    const revenuePerDay = userRatio * blockPerDay * algo.block_reward24;
    return {
      revenue: revenuePerDay * algo.exchange_rate24 * course,
      perf: data.speed,
      cons: data.consumpation,
      algo: algo.algorithm,
    };
  }

  const res =
    ((data.speed * 86400 * algo.block_reward24) /
      (4294967296 * algo.difficulty24)) *
    course;

  return {
    revenue: res,
    perf: data.speed,
    cons: data.consumpation,
    algo: algo.algorithm,
  };
};

const saveDevices = (dev: DeviceI[]) => {
  sessionStorage.setItem("devices", JSON.stringify(dev));
};

export const getDevices = (spa?: boolean) => {
  if (
    sessionStorage.getItem("devices") === null ||
    !sessionStorage.getItem("devices")
  )
    return [];

  if (spa) {
    const dev: DeviceI[] = JSON.parse(
      sessionStorage.getItem("devices") as string
    );
    const spaDev = dev.map((d) => d.name);
    return spaDev;
  }

  return JSON.parse(sessionStorage.getItem("devices") as string);
};
